// admin后台组件
import Index from '../views/Admin/Index';
import Home from "../views/Admin/Other/Home";
import Login from '../views/Admin/Other/Login';
import AdminInfo from "../views/Admin/Other/AdminInfo";
import Users from "../views/Admin/User/Student";
import AdminUsers from "../views/Admin/User/AdminUsers";
import Courses from "../views/Admin/Course/Courses";
import AddCourse from "../views/Admin/Course/AddCourse";
import Breadcrumb from '../views/Admin/Other/Breadcrumb';
import Comments from "../views/Admin/Comment/Comment";
import ChapterList from "../views/Admin/Course/ChapterList";
import Order from "../views/Admin/Order/Order";
import Shuffles from "../views/Admin/Setting/Shuffle";


export default [
    {
        path: '/admin',
        component: Login
    },
    {
        path: '/mg',
        component: Index,
        redirect: '/mg/userManager/users',
        meta: {title: '首页'},
        children: [
            {path: 'home', component: Home},
            {
                path: 'userManager',
                component: Breadcrumb,
                meta: {title: '用户管理'},
                children: [
                    {path: 'users', component: Users, meta: {title: '学生管理'}},
                    {path: 'adminusers', component: AdminUsers, meta: {title: '客服管理'}},
                ]
            },
            {
                path: 'courseManager',
                component: Breadcrumb,
                meta: {title: '课程管理'},
                children: [
                    {path: 'courses', component: Courses, meta: {title: '课程管理'}},
                    {path: 'addCourse', component: AddCourse, meta: {title: '添加课程'}},
                    {path: 'course/:course_id', component: ChapterList, meta: {title: '章节信息'}},
                ]
            },
            {
                path: 'commentManager',
                component: Breadcrumb,
                meta: {title: '评论管理'},
                children: [
                    {path: 'comments', component: Comments, meta: {title: '评论管理'}},
                ]
            },
            {
                path: 'orderManager',
                component: Breadcrumb,
                meta: {title: '订单管理'},
                children: [
                    {path: 'order', component: Order, meta: {title: '订单管理'}},
                ]
            },
            {
                path: 'shuffleManager',
                component: Breadcrumb,
                meta: {title: '轮播管理'},
                children: [
                    {path: 'shuffle', component: Shuffles, meta: {title: '轮播管理'}},
                ]
            }
        ]
    }

]
